import { number, object } from "yup";
import { type YupOutputType } from "~/lib/utils";

export const BaseJobDataSchema = object({ companyId: number().required() });

export type BaseJobData = YupOutputType<typeof BaseJobDataSchema>;
